import React, { Dispatch, createContext } from "react";
import { CarrinhoDTO, CartAction } from "./useCarrinhoReducer";

interface CarrinhoContextType {
    carrinhoReducer: CarrinhoDTO;
  dispatch: Dispatch<CartAction>;
}

const CarrinhoContext = React.createContext<CarrinhoContextType>(
  {} as CarrinhoContextType
);

export default CarrinhoContext;
